import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    outlets: [],
    outlet: {},
    pagination: {},
    new_outlet: {},
    validate_form: {
      name: [
        { required: true, message: 'Outlet name is required', trigger: 'blur' },
      ],
      p_code: [
        { required: true, message: 'Unique identifier/code is required', trigger: 'blur' },
      ],
      address: [
        { required: true, message: 'Address is required', trigger: 'blur' },
      ],
      country_id: [
        { required: true, message: 'Country is required', trigger: 'blur' },
      ],
      state_id: [
        { required: true, message: 'State is required', trigger: 'blur' },
      ],
      city_id: [
        { required: false, type: 'string' },
      ],
      status: [
        { type: 'boolean', required: false },
      ],
    },
  },
  actions,
  mutations,
  getters,
};
